import React, { useEffect, useState, useRef } from "react";
import OpenAI from "openai";
import { FaCopy } from "react-icons/fa";
import { toast } from "react-toastify";
import Input from "../../components/input";
import useAxiosInstance from "../../hooks/useAxios";
import Slider from "@mui/material/Slider";
import JsonView from "@uiw/react-json-view";
import PlaygroundModel from "./PlaygroundModel";
// import sampleReportData from "./data.json";

const Playground = () => {
  // Form States
  const [prompt, setPrompt] = useState("");
  const [promptId, setPromptId] = useState(0);
  const [temperature, setTemperature] = useState(1);
  const [maxTokens, setMaxTokens] = useState(100);
  const [modelType, setModelType] = useState("");
  const [topP, setTopP] = useState(0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0);
  const [presencePenalty, setPresencePenalty] = useState(0);
  const [engine, setEngine] = useState({});
  const [systemMessage, setSystemMessage] = useState("You are a helpful assistant.");
  const [functions, setFunctions] = useState(null);
  
  return (
    <PlaygroundModel
      prompt={prompt}
      setPrompt={setPrompt}
      promptId={promptId}
      setPromptId={setPromptId}
      temperature={temperature}
      setTemperature={setTemperature}
      maxTokens={maxTokens}
      setMaxTokens={setMaxTokens}
      modelType={modelType}
      setModelType={setModelType}
      topP={topP}
      setTopP={setTopP}
      frequencyPenalty={frequencyPenalty}
      setFrequencyPenalty={setFrequencyPenalty}
      presencePenalty={presencePenalty}
      setPresencePenalty={setPresencePenalty}
      engine={engine}
      setEngine={setEngine}
      systemMessage={systemMessage}
      setSystemMessage={setSystemMessage}
      functions={functions}
      setFunctions={setFunctions}
    />
  );
};

export default Playground;
